import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../services/Authentication";

import "./NewSubject.scss";
import Button from "../../controls/buttons/Button";
import arrowLeft from '../../../assets/arrowLeft.png';
import placeholder from '../../../assets/Subject-cover-placeholder.png';
import ClearIcon from '@material-ui/icons/Clear';
import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import app from "../../../services/base";
import { generateUniqueFirestoreId } from '../../../utils/math';
import MenuButton from "../../controls/buttons/MenuButton";
import ModuleItem from "../ModuleItem/ModuleItem";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import ViewClasse from "../ViewClasse/ViewClasse";
import Camera from '../../../assets/camera.png';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import TextField from '@mui/material/TextField';
import Trash from '../../../assets/trash.png';
import { cardClasses, MenuItem } from "@mui/material";
import { DeleteDialog } from "../../modal";
import { createTheme } from '@mui/material/styles';


function NewSubject({ communityList, changeScreen, subject }) {

    const [eventId, setEventId] = useState(undefined);
    const [showLoading, setShowLoading] = useState(false);
    const [subjectId, setSubjectId] = useState('');
    const [subjectName, setSubjectName] = useState('');
    const [subjectCover, setSubjectCover] = useState('');
    const [subjectDesc, setSubjectDesc] = useState('');
    const [subjectTags, setSubjectTags] = useState([]);
    const [subjectGroup, setSubjectGroup] = useState([]);
    const [subjectModules, setSubjectModules] = useState([]);
    const [tempTags, setTempTags] = useState('');
    const [moduleName, setModuleName] = useState('');
    const [moduleIndex, setModuleIndex] = useState(null);
    const [classIndex, setClassIndex] = useState(null);
    const [className, setClassName] = useState('');
    const [classModule, setClassModule] = useState(null);
    const [classType, setClassType] = useState('');
    const [classLink, setClassLink] = useState('');
    const [classDesc, setClassDesc] = useState('');
    const [classDate, setClassDate] = useState('');
    const [classTime, setClassTime] = useState('');
    const [classFiles, setClassFiles] = useState([]);
    const [classContent, setClassContent] = useState([]);
    const [classContentTemp, setClassContentTemp] = useState("");
    const [classStep, setClassStep] = useState(0);
    const [classCounter, setClassCounter] = useState(0);
    const [fileCounter, setFileCounter] = useState(0);
    const [studentData, setStudentData] = useState({ classIds: [], classData: {} });
    const [createType, setCreateType] = useState('');
    const [fileType, setFileType] = useState('');
    const [tempGroup, setTempGroup] = useState(null);
    const [viewAula, setViewAula] = useState(false);
    const [totalClasses, setTotalClasses] = useState([]);
    const [preview, setPreview] = useState()
    const [modalAction, setModalAction] = useState({});
    const [open, setOpen] = useState(false);
    const { currentUser } = useContext(AuthContext);

    const classSteps = ['Informações da aula', 'Link e descrição', 'Material complementar'];
    const classModes = ['Síncrona', 'Assíncrona'];


    useEffect(() => {
        if (subject) {
            setSubjectId(subject.subjectId)
            setSubjectName(subject.name ? subject.name : '');
            setSubjectCover(subject.cover ? subject.cover : '')
            setSubjectDesc(subject.description ? subject.description : '')
            setSubjectTags(subject.tags ? subject.tags : [])
            setSubjectGroup(subject.groupsInfo ? subject.groupsInfo : [])
            setSubjectModules(subject.subjectModules ? subject.subjectModules : [])
            let count = 0;
            if (subject.subjectModules) {
                subject.subjectModules.forEach(el => {

                    count = count + el.classList.length
                });
            }
            let aulas = [];
            setTotalClasses(count)
            setClassCounter(subject.classCounter);
            setFileCounter(subject.fileCounter);
            setStudentData(subject.studentData);
        }


    }, []);

    useEffect(() => {
        let count = 0;
        if (subjectModules) {
            subjectModules.forEach(el => {

                count = count + el.classList.length
            });
        }
        setTotalClasses(count)



    }, [subjectModules]);

    function onChangeName(event) {
        setSubjectName(event.target.value);
    }

    function onChangeModuleName(event) {
        setModuleName(event.target.value);
    }

    function onChangeClassName(event) {
        setClassName(event.target.value);
    }

    function onChangeClassLink(event) {
      // if event.target.value contains youtu.be/id_of_video or youtube.com/embed/id_of_video convert to youtube.com/watch?v=id_of_video
      if (event.target.value.includes("youtu.be") || event.target.value.includes("youtube.com/embed")) {
        let videoId = event.target.value.split("/").pop();
        setClassLink("https://www.youtube.com/watch?v=" + videoId);
      } else {
        setClassLink(event.target.value);
      }
    }

    function onChangeClassTime(event) {
        setClassTime(event.target.value);
    }
    function onChangeClassDate(event) {
        setClassDate(event.target.value);
    }

    function onChangeClassDesc(event) {
        setClassDesc(event.target.value);
    }


    function onChangeDescription(event) {
        setSubjectDesc(event.target.value);
    }

    function onChangeTag(event) {
        setTempTags(event.target.value);
    }

    function addTag() {
        let array = subjectTags;
        if (!array.includes(tempTags) && tempTags.length > 0) {
            array.push(tempTags);
            setSubjectTags(array);
        }
        setTempTags('');
    }

    function onChangeGroup(event, value) {
        setTempGroup(event.target.value);
    }

    function addGroup() {
        let array = subjectGroup;
        if (!array.includes(tempGroup) && tempGroup != null) {
            array.push(tempGroup);
            setSubjectGroup(array);
        }
        setTempGroup(null);
    }

    function renderTags() {
        let array = subjectTags;
        let tags = [];
        array.forEach(el => {
            tags.push(
                <Grid item>
                    <Chip label={el} color="primary" deleteIcon={<ClearIcon />} onDelete={() => deleteTag(el)} />
                </Grid>
            )
        });
        return tags;
    }

    function deleteTag(tag) {
        let array = [...subjectTags];
        const index = subjectTags.indexOf(tag);
        if (index > -1) {
            array.splice(index, 1);
            setSubjectTags(array);
        }
    }

    function renderGroups() {
        let array = subjectGroup;
        let tags = [];
        array.forEach(el => {
            tags.push(
                <Grid item>
                    <Chip label={el.title} color="primary" deleteIcon={<ClearIcon />} onDelete={() => deleteGroup(el)} />
                </Grid>
            )
        });
        return tags;
    }

    function deleteGroup(tag) {
        let array = [...subjectGroup];
        const index = subjectGroup.indexOf(tag);
        if (index > -1) {
            array.splice(index, 1);
            setSubjectGroup(array);
        }
    }

    async function UploadGroupImage(id) {
        if (subjectCover && subjectCover.photo) {
            return subjectCover.photo;
        }
        if (!subjectCover) {
            return null;
        }
        const profilesImages = app.storage().ref(`subjects/${id}/imagens/${generateUniqueFirestoreId()}`);

        await profilesImages.put(subjectCover);
        const photoURL = await profilesImages.getDownloadURL();
        setPreview(photoURL);

        return photoURL;
    }

    async function UploadClassDoc(file, id) {
        if (file && file.link) {
            return file.link;
        }

        const ClassFile = app.storage().ref(`subjects/${id}/files/${generateUniqueFirestoreId()}`);

        await ClassFile.put(file);
        const fileURL = await ClassFile.getDownloadURL();

        return fileURL;
    }

    function addModule(draft) {
        let array = [...subjectModules];
        if (moduleName != '') {
            let module = {
                name: moduleName,
                draft: draft,
                classList: [],
            }
            array.push(module);
            setSubjectModules(array);
            setModuleName('');
            setCreateType('');
        }
    }

    function addClass(draft) {
        if (classModule != null) {
            let array = [...subjectModules[classModule].classList];
            let classe = {
                name: className,
                draft: draft,
                classType: classType,
                classLink: classLink,
                classDesc: classDesc,
                classDate: classDate,
                classTime: classTime,
                classFiles: classFiles,
                classContent: classContent.filter(n => n),
                classId: classCounter + 1
            }
            let sData = studentData;
            sData.classIds.push(classCounter + 1);
            array.push(classe);
            let modules = [...subjectModules];
            modules[classModule].classList = array;
            setSubjectModules(modules);
            setClassCounter(classCounter + 1);
            setStudentData(sData);
            emptyClass();
            setCreateType('');
        }
    }

    function emptyClass() {
        setClassName('')
        setClassModule('')
        setClassType('')
        setClassLink('')
        setClassDesc('')
        setClassDate('');
        setClassTime('')
        setClassStep(0)
        setClassFiles([])
        setClassContent([])
    }

    function renderModules() {
        let array = [...subjectModules];
        let modules = []
        array.forEach((el, index) => {
            modules.push(
                <Grid item>
                    <ModuleItem module={el} admin={true} handleEdit={editModule} handleDelete={() => {
                        setModalAction({
                            actionConfirmation: () => {
                                deleteModule(index);
                            },
                            title: "Tem certeza de que deseja excluir este módulo?",
                            legend:
                                "Esta é uma ação irreversível e todas as aulas e materiais adicionados ao módulo serão perdidos",
                            buttonConfirmation: true,
                            textCancel: "Não excluir",
                            textConfirmation: "Excluir módulo",
                            actionCancel: () => setOpen(false),
                        });
                        setOpen(true);
                    }}



                        modIndex={index}
                        classEdit={editClass} classDelete={modalDeleteClass} viewClass={viewClass} />
                </Grid>
            )
        });
        return modules;
    }

    function nextStep() {

        if (classStep == 0) {
            if (className != '' && classType != '' && classModule != null) {
                if (classType == 'Assíncrona') {
                    setClassStep('1A');
                }
                else {
                    setClassStep('1S');
                }
            }
        }
        else if (classStep == '1A') {
            if (classLink != '') {
                setClassStep(2)
            }
        }
        else if (classStep == '1S') {
            if (classLink != '' || classTime == '' || classDate == '') {
                setClassStep(2)
            }
        }
    }

    function prevStep() {

        if (classStep == '1A' || classStep == '1S') {
            setClassStep(0);
        }
        else if (classStep == 2) {
            if (classType == 'Assíncrona') {
                setClassStep('1A');
            }
            else {
                setClassStep('1S');
            }
        }
    }

    function formatFileSize(bytes, decimalPoint) {
        if (bytes == 0) return '0 Bytes';
        var k = 1000,
            dm = decimalPoint || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    function renderClassFiles() {
        let array = [...classFiles];
        let files = []
        array.forEach((el, index) => {
            files.push(
                <div className="file-div">
                    <div className="file-div-left">
                        <label> {el.name}</label>
                    </div>
                    <div className="file-div-right">
                        <label>{formatFileSize(el.size)}</label>
                        <img src={Trash} onClick={() => deleteClassFile(index)} />
                    </div>
                </div>

            )
        });
        return files;
    }

    function validateURL(link) {
        if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0) {
            return (link)
        }
        else {
            return ("https://" + link)
        }
    }

    function renderLinks() {
        let array = [...classContent];
        let files = [];
        array.forEach((el, index) => {

            files.push(
                <div className="file-div">
                    <div className="file-div-left">
                        <a href={validateURL(el)} target="_blank" rel="noreferrer noopener">
                            {el}
                        </a>
                    </div>
                    <div className="file-div-right">
                        <img src={Trash} onClick={() => deleteClassContent(index)} />
                    </div>
                </div>
            )


        });
        return files;
    }

    function deleteClassContent(index) {
        let array = [...classContent];
        array.splice(index, 1);
        setClassContent(array);
    }

    function addClassContent() {
        if (classContentTemp != "") {
            let array = [...classContent];
            array.push(classContentTemp);
            setClassContent(array);
            setClassContentTemp("")
        }

    }

    function deleteClassFile(index) {
        let array = [...classFiles];
        array.splice(index, 1);
        setClassFiles(array);
    }

    function addClassFile(element) {
        let file = element && element.target && element.target.files ? element.target.files[0] : null;
        if (!file) {
            return;
        }
        if (file.size > 20000000) {
            alert('O tamanho do arquivo ultrapassa o limite máximo de 20Mb permitido.', 'error');
            return;
        }

        let array = [...classFiles];
        array.push(file)
        setClassFiles(array);
        element.target.value = null;
    }

    function renderSteps(step) {
        switch (step) {
            case 0:
                return (
                    <>

                        <div className="new-subjects-modules-creation">
                            <div className="new-module-label">
                                {createType == 'editAula' ? <label >Editar aula </label> : <label >Adicionar nova aula </label>}
                            </div>
                            <div className="new-class-stepper">
                                <Stepper activeStep={classStep} alternativeLabel>
                                    {classSteps.map((label) => (
                                        <Step key={label} sx={{ fontSize: 18 }}>
                                            <StepLabel sx={{ fontSize: 18 }}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>
                            <div className="new-subjects-input-label">
                                <label className="new-subjects-input-label-text">Nome da aula</label>

                                <TextField
                                    type="text"
                                    value={className}
                                    placeholder="Nome da aula"
                                    name="name"
                                    id="name"
                                    className="Module-name-field"
                                    enterKeyHint="done"
                                    onChange={onChangeClassName}
                                />
                            </div>
                            <div className="new-subjects-input-label">
                                <label className="new-subjects-input-label-text">Modulo</label>
                                <TextField
                                    select className="Module-name-select"
                                    placeholder="Selecione o módulo"
                                    value={classModule}
                                    onChange={event => setClassModule(event.target.value)}
                                >
                                    <MenuItem value={null} sx={{ display: 'none' }}> Selecione o módulo </MenuItem>
                                    {subjectModules.map((module, index) => <MenuItem key={index} value={index}>{module.name}</MenuItem>)}
                                </TextField>
                            </div>
                            <div className="new-subjects-input-label">
                                <label className="new-subjects-input-label-text">Modo da aula</label>
                                <TextField select className="Module-name-select"
                                    placeholder="Selecione o modo"
                                    value={classType}
                                    onChange={event => setClassType(event.target.value)}
                                >
                                    <MenuItem value={''} sx={{ display: 'none' }}> Selecione o modo </MenuItem>
                                    {classModes.map((mode, index) => <MenuItem value={mode}>{mode}</MenuItem>)}
                                </TextField>
                            </div>
                            <div className="new-modules-btn">
                                <label onClick={() => setCreateType('')}>
                                    <Button className={'outlined-button'}>
                                        <span>Cancelar</span>
                                    </Button>
                                </label>
                                <div >
                                    <label onClick={() => nextStep()}>
                                        <Button className="primary-button " disabled={className == '' || classType == '' || classModule == null}>
                                            <span>Próximo</span>
                                        </Button>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </>
                )
                break;
            case '1A':
                return (
                    <>
                        <div className="new-subjects-modules-creation">
                            <div className="new-module-label">
                                {createType == 'editAula' ? <label >Editar aula </label> : <label >Adicionar nova aula </label>}
                            </div>
                            <div className="new-class-stepper">
                                <Stepper activeStep={1} alternativeLabel>
                                    {classSteps.map((label) => (
                                        <Step key={label} sx={{ fontSize: 18 }}>
                                            <StepLabel sx={{ fontSize: 18 }}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>
                            <div className="new-subjects-input-label">
                                <label className="new-subjects-input-label-text">Link da aula</label>
                                <TextField
                                    type="text"
                                    value={classLink}
                                    placeholder="Link da aula"
                                    name="name"
                                    id="name"
                                    className="Module-name-field"
                                    enterKeyHint="done"
                                    onChange={onChangeClassLink}
                                />
                            </div>
                            <div className="new-subjects-input-label">
                                <label className="new-subjects-input-label-text">Descrição da aula</label>
                                <TextField
                                    type="text"
                                    rows="4"
                                    multiline
                                    value={classDesc}
                                    className="Subject-description-field-fixed"
                                    placeholder="Adicione uma descrição à aula (opcional)"
                                    name="description"
                                    id="description"
                                    enterKeyHint="done"
                                    onChange={onChangeClassDesc}
                                />
                            </div>
                            <div className="new-modules-btn">
                                <label onClick={() => prevStep()}>
                                    <Button className={'outlined-button'}>
                                        <span>Anterior</span>
                                    </Button>
                                </label>
                                <div >
                                    <label onClick={() => nextStep()}>
                                        <Button className="primary-button " disabled={classLink == ''}>
                                            <span>Próximo</span>
                                        </Button>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </>
                )
                break;
            case '1S':
                return (
                    <>
                        <div className="new-subjects-modules-creation">
                            <div className="new-module-label">
                                {createType == 'editAula' ? <label >Editar aula </label> : <label >Adicionar nova aula </label>}
                            </div>
                            <div className="new-class-stepper">
                                <Stepper activeStep={1} alternativeLabel>
                                    {classSteps.map((label) => (
                                        <Step key={label} sx={{ fontSize: 18 }}>
                                            <StepLabel sx={{ fontSize: 18 }}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>
                            <div className="new-subjects-input-label">
                                <label className="new-subjects-input-label-text">Link da aula</label>
                                <TextField
                                    type="text"
                                    value={classLink}
                                    placeholder="Link da aula"
                                    name="name"
                                    id="name"
                                    className="Module-name-field"
                                    enterKeyHint="done"
                                    onChange={onChangeClassLink}
                                />
                            </div>
                            <div className="aula-time-container">
                                <div className="new-subjects-input-label">
                                    <label className="new-subjects-input-label-text">Data</label>
                                    <TextField
                                        type="date"
                                        value={classDate}
                                        placeholder="Selecione a Data"
                                        name="name"
                                        id="name"
                                        className="Module-time-field"
                                        enterKeyHint="done"
                                        onChange={onChangeClassDate}
                                    />
                                </div>
                                <div className="new-subjects-input-label">
                                    <label className="new-subjects-input-label-text">Horário</label>
                                    <TextField
                                        type="time"
                                        value={classTime}
                                        placeholder="Selecione o horário"
                                        name="name"
                                        id="name"
                                        className="Module-time-field"
                                        enterKeyHint="done"
                                        onChange={onChangeClassTime}
                                    />
                                </div>
                            </div>

                            <div className="new-subjects-input-label">
                                <label className="new-subjects-input-label-text">Descrição da aula</label>
                                <TextField
                                    type="text"
                                    rows="4" cols="50"
                                    multiline
                                    value={classDesc}
                                    className="Subject-description-field-fixed"
                                    placeholder="Adicione uma descrição à aula (opcional)"
                                    name="description"
                                    id="description"
                                    enterKeyHint="done"
                                    onChange={onChangeClassDesc}
                                />
                            </div>
                            <div className="new-modules-btn">
                                <label onClick={() => prevStep()}>
                                    <Button className={'outlined-button'}>
                                        <span>Anterior</span>
                                    </Button>
                                </label>
                                <div >
                                    <label onClick={() => nextStep()}>
                                        <Button className="primary-button " disabled={classLink == '' || classTime == '' || classDate == ''}>
                                            <span>Próximo</span>
                                        </Button>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </>
                )
                break;
            case 2:
                return (
                    <>
                        <div className="new-subjects-modules-creation">
                            <div className="new-module-label">
                                {createType == 'editAula' ? <label >Editar aula </label> : <label >Adicionar nova aula </label>}
                            </div>
                            <div className="new-class-stepper">
                                <Stepper activeStep={classStep} alternativeLabel>
                                    {classSteps.map((label) => (
                                        <Step key={label} sx={{ fontSize: 18 }}>
                                            <StepLabel sx={{ fontSize: 18 }}>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </div>
                            <div>
                                <TextField
                                    select className="Module-name-select"
                                    label="Tipo de Material"
                                    helperText="*Opcional"
                                    value={fileType}
                                    onChange={event => setFileType(event.target.value)}
                                >
                                    <MenuItem value={null} sx={{ display: 'none' }}> Tipo de Material </MenuItem>
                                    <MenuItem value={'Link'} > Link </MenuItem>
                                    <MenuItem value={'Arquivo'} > Arquivo </MenuItem>
                                </TextField>
                            </div>
                            {fileType == 'Link' &&
                                <div className="new-modules-btn">
                                    <TextField
                                        type="text"
                                        value={classContentTemp}
                                        label={"Link"}
                                        placeholder="Insira aqui o link do material"
                                        InputLabelProps={{ shrink: true }}
                                        name="name"
                                        id="name"
                                        className="Module-link-field"
                                        enterKeyHint="done"

                                        onChange={(event) => setClassContentTemp(event.target.value)}
                                    />
                                    <label onClick={() => addClassContent()}>
                                        <Button className={'primary-button input-button'}>
                                            <span>Adicionar</span>
                                        </Button>
                                    </label>

                                </div>}
                            {fileType == 'Arquivo' &&
                                <div className="new-file-btn">
                                    <div className="class-btn-file">
                                        <Button className={'primary-button'}>
                                            <span>+ Adicionar Arquivo</span>
                                        </Button>
                                        <input type="file" onChange={addClassFile} accept="image/*,.pdf,video/* ,.doc,.docx,.ppt, .pptx " />
                                    </div>
                                    <label >
                                        *Tamanho máximo do arquivo 20mb
                                    </label>

                                </div>}
                            {classFiles.length > 0 && renderClassFiles()}

                            {classContent.length > 0 && renderLinks()}
                            <div className="new-modules-btn">
                                <label onClick={() => prevStep()}>
                                    <Button className={'outlined-button'}>
                                        <span>Anterior</span>
                                    </Button>
                                </label>
                                <div >
                                    <label onClick={() => nextStep()}>
                                        <div >
                                            <label onClick={() => { addClass(false) }}>
                                                <Button className="primary-button btn-left">
                                                    <span>Concluir</span>
                                                </Button>
                                            </label>
                                            <label >
                                                <MenuButton className="primary-button btn-right" items={ClassMenu}>
                                                    <KeyboardArrowDownIcon />
                                                </MenuButton>
                                            </label>
                                        </div>
                                    </label>
                                </div>
                            </div>

                        </div>
                    </>
                )
                break;
        }
        return (<></>)

    }




    function viewClass(indexM, indexC) {
        setModuleIndex(indexM);
        setClassIndex(indexC);
        setViewAula(true);
    }

    function deleteModule(index) {
        let array = [...subjectModules];
        array.splice(index, 1);
        setSubjectModules(array);
        setModuleName('');
        setCreateType('');
        setModuleIndex(null);
        setOpen(false)
    }

    function modalDeleteClass(indexM, indexC) {
        let array = [...subjectModules];

        setModalAction({
            actionConfirmation: () => {
                deleteClass(indexM, indexC);
            },
            title: "Tem certeza que deseja excluir a aula " + array[indexM].classList[indexC].name + "?",
            legend:
                "Esta é uma ação irreversível",
            buttonConfirmation: true,
            textCancel: "Não excluir",
            textConfirmation: "Excluir aula",
            actionCancel: () => setOpen(false),
        });
        setOpen(true);


    }

    function deleteClass(indexM, indexC) {
        let array = [...subjectModules];
        let id = array[indexM].classList[indexC].classId;

        let sData = studentData;
        sData.classIds.splice(sData.classIds.findIndex((a) => a == id), 1);

        array[indexM].classList.splice(indexC, 1)
        setStudentData(sData);
        setSubjectModules(array);
        emptyClass();
        setCreateType('');
        setModuleIndex(null);
        setClassIndex(null);
        setOpen(false)
    }

    function editModule(module, index) {
        let array = [...subjectModules];
        array.splice(index, 1, module);
        setSubjectModules(array);
        setModuleName('');
        setCreateType('');
        setModuleIndex(null);

    }

    function editClass(aula, modIndex, index) {



        let array = [...subjectModules[modIndex].classList];
        let classe = aula;
        array.splice(index, 1, classe);
        let modules = [...subjectModules];
        modules[modIndex].classList = array;
        setSubjectModules(modules);
        emptyClass();
        setCreateType('');



    }

    const ClassMenu = [
        {
            option: 'Tornar aula disponível',
            onClick: () => { createType == 'editAula' ? editClass(false) : addClass(false) }
        },
        {
            option: 'Salvar como rascunho',
            onClick: () => { createType == 'editAula' ? editClass(true) : addClass(true) }
        },
    ]

    const ModuleMenu = [
        {
            option: 'Tornar módulo disponível',
            onClick: () => addModule(false)
        },
        {
            option: 'Salvar como rascunho',
            onClick: () => addModule(true)
        },
    ]



    async function saveSubject(leave) {
        if (subjectGroup.length > 0 && subjectName != "") {
            setShowLoading(true)
            let groupIds = [];
            let fCounter = fileCounter;
            subjectGroup.forEach(el => {
                groupIds.push(el.id);
            })
            let ref;
            if (subjectId == "") {
                ref = app.firestore().collection('disciplina').doc();
                setSubjectId(ref.id);
            }
            let subModules = [...subjectModules];
            for (let i = 0; i < subModules.length; i++) {
                for (let j = 0; j < subModules[i].classList.length; j++) {
                    for (let k = 0; k < subModules[i].classList[j].classFiles.length; k++) {
                        let name = subModules[i].classList[j].classFiles[k].name;
                        let size = subModules[i].classList[j].classFiles[k].size;
                        let fileURL = await UploadClassDoc(subModules[i].classList[j].classFiles[k], subjectId ? subjectId : ref.id);
                        if (subModules[i].classList[j].classFiles[k].id) {
                            subModules[i].classList[j].classFiles[k] = { id: subModules[i].classList[j].classFiles[k].id, link: fileURL, name: name, size: size };
                        }
                        else {
                            fCounter = fCounter + 1;
                            setFileCounter(fCounter);
                            subModules[i].classList[j].classFiles[k] = { id: fCounter, link: fileURL, name: name, size: size };
                        }

                    }
                }
            }


            const imageURL = await UploadGroupImage(subjectId ? subjectId : ref.id);
            setFileCounter(fCounter);
            let sData = studentData;

            let subjectFields = {
                subjectId: subjectId ? subjectId : ref.id,
                groupIds: groupIds,
                groupsInfo: subjectGroup,
                description: subjectDesc,
                name: subjectName,
                lastUpdate: new Date(),
                tags: subjectTags,
                cover: imageURL ? { photo: imageURL, name: subjectCover.name } : null,
                professorId: currentUser.id,
                subjectModules: subModules,
                classCounter: classCounter,
                fileCounter: fCounter,
                studentData: sData,
            }
            await app.firestore().collection('disciplina').doc(subjectId ? subjectId : ref.id).set(subjectFields);
            setShowLoading(false);
            if (leave) {
                changeScreen(null, 'main');
            }
        }

    }

    useEffect(() => {
        if (!subjectCover) {
            setPreview(undefined)
            return
        }
        if (subjectCover && subjectCover.photo) {
            setPreview(subjectCover.photo)
            return
        }
        if (subjectCover.type) {
            const objectUrl = URL.createObjectURL(subjectCover)
            setPreview(objectUrl)

            // free memory when ever this component is unmounted
            return () => URL.revokeObjectURL(objectUrl)
        }


    }, [subjectCover])

    async function uploadCover(element) {
        let file = element && element.target && element.target.files ? element.target.files[0] : null;
        if (!file) {
            return;
        } else if (file && !(file.name.toLowerCase().includes('jpg') || file.name.toLowerCase().includes('jpeg') ||
            file.name.toLowerCase().includes('png') || file.name.toLowerCase().includes('mp4'))) {
            alert('Tipo de arquivo não permitido. Anexar apenas JPG, JPEG, PNG ou MP4.', 'error');
            return;
        }
        if (file.size > 20000000) {
            alert('O tamanho do arquivo ultrapassa o limite máximo de 20Mb permitido.', 'error');
            return;
        }
        setSubjectCover(file);
        element.target.value = null;
    };

    const autoCompleteProps = {
        options: communityList,
        getOptionLabel: (option) => option.title,
    };

    function getClassDate() {
        let d = new Date(subjectModules[moduleIndex].classList[classIndex].classDate)
        return (d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear())
    }

    const theme = createTheme({
        components: {
            MuiTextField: {
                defaultProps: {
                    size: "small",
                },
            },
            MuiFormControl: {
                defaultProps: {
                    size: "small",
                },
            },
            MuiInputLabel: {
                defaultProps: {
                    sx: {
                        fontSize: "13px",
                        top: 2,
                    },
                },
                styleOverrides: {
                    shrink: ({ ownerState, theme }) => ({
                        ...(ownerState.shrink && {
                            fontSize: "1rem !important",
                            top: "-1 !important",
                        }),
                    }),
                },
            },
        },
    });

    return (
        <>
            <DeleteDialog open={open} {...modalAction} />
            {showLoading && <div class="loader" />}
            {!viewAula && <Grid container>
                <Grid item xs={12}>
                    <div className="new-subjects-main">

                        <div className="new-title-subjects">
                            Disciplinas
                        </div>

                        <div className="new-subjects-header">
                            <div className="new-subjects-breadcrumb">
                                <img src={arrowLeft} style={{ height: '28px' }}></img>
                                <span className="subtitle-new-subjects" onClick={(e) => changeScreen(e, 'main')}>{subject ? <span >Editar conteúdo da disciplina</span> : <span >Nova Disciplina</span>}</span>
                            </div>
                            <div className="new-subjects-modules-btn">
                                <label onClick={(e) => changeScreen(e, 'main')}>
                                    <Button className={'gray-button'}>
                                        <span>Cancelar</span>
                                    </Button>
                                </label>
                                {subjectId ?
                                    <label onClick={() => saveSubject(true)}>
                                        <Button disabled={subjectGroup.length == 0 || subjectName == ""}>
                                            <span>Salvar</span>
                                        </Button>
                                    </label> :
                                    <label onClick={() => {
                                        if (!(subjectGroup.length == 0 || subjectName == "")) {
                                            setModalAction({
                                                actionConfirmation: () => {
                                                    setOpen(false); saveSubject(false);
                                                },
                                                type: 'confirm',
                                                title: "Gostaria de seguir para a adição de módulos e aulas?",
                                                legend:
                                                    "Se preferir você pode voltar para a página de disciplinas e, em outro momento adicionar os módulos e aulas.",
                                                buttonConfirmation: true,
                                                textCancel: "Voltar para disciplinas",
                                                textConfirmation: "Adicionar conteúdo",
                                                actionCancel: () => { setOpen(false); saveSubject(true) },
                                            });
                                            setOpen(true);
                                        }

                                    }


                                    }>
                                        <Button disabled={subjectGroup.length == 0 || subjectName == ""}>
                                            <span>Salvar</span>
                                        </Button>
                                    </label>}

                            </div>
                        </div>

                        <div className="new-subjects-input-label">
                            <label className="new-subjects-input-label-text">
                                Nome
                            </label>
                            <TextField
                                type="text"
                                value={subjectName}
                                className="Subject-name-field"
                                sx={{ width: '66%' }}
                                label="Nome da Disciplina"
                                name="name"
                                id="name"
                                enterKeyHint="done"
                                onChange={onChangeName}
                            />
                        </div>

                        <div className="new-subjects-input-label">
                            <label className="new-subjects-input-label-text">
                                Imagem
                            </label>

                            <div className="new-subjects-image">
                                {preview ? <img className={'cover'} src={preview} ></img>
                                    :
                                    <div className="new-subjects-image-label">
                                        <img style={{ height: '24px', width: '24px' }} src={Camera}>
                                        </img>
                                        <label>Adicionar imagem</label>
                                    </div>
                                }
                                <input type="file" onChange={uploadCover} />

                            </div>
                        </div>


                        <div className="new-subjects-input-label">
                            <label className="new-subjects-input-label-text">
                                Descrição
                            </label>

                            <TextField
                                type="text"
                                multiline
                                rows={4}
                                label={"Descrição da disciplina"}
                                value={subjectDesc}
                                className="Subject-description-field"
                                placeholder="Adicione uma descrição à Disciplina (opcional)"
                                name="description"
                                id="description"
                                enterKeyHint="done"

                                onChange={onChangeDescription}
                            />
                        </div>
                        <div className="new-subjects-tag-label">
                            <label > Grupos</label>
                        </div>
                        <div >
                            <Autocomplete
                                {...autoCompleteProps}
                                id="autocomplete-group"
                                autoComplete
                                autoHighlight
                                value={tempGroup}
                                onChange={(event, newValue) => {
                                    setTempGroup(newValue);
                                }}
                                renderInput={(params) => (
                                    <div ref={params.InputProps.ref} className="Subject-tag-div">
                                        <TextField
                                            {...params.inputProps}
                                            type="text"
                                            label={"Digite o nome de um grupo"}
                                            className="Subject-tag-field"
                                            placeholder="Adicione os Grupos a qual a disciplina será disponibilizada"
                                            name="name"
                                            enterKeyHint="done"
                                        />
                                        <div className="Subject-tag-label-container">
                                            <label className={tempGroup != null ? 'subject-label-btn' : 'subject-label-btn-hidden'}
                                                onClick={addGroup}> Adicionar </label>
                                        </div>

                                    </div>

                                )}
                            />


                        </div>

                        {subjectGroup.length > 0 && <div className="new-subjects-tags">
                            <Grid container direction="row" justifyContent="flex-start" spacing={1}>
                                {renderGroups()}
                            </Grid>

                        </div>}
                        <div className="new-subjects-tag-label">
                            <label > Tags</label>
                        </div>

                        <div className="Subject-tag-div">
                            <TextField
                                type="text"
                                value={tempTags}
                                label={"Digite um tema"}
                                className="Subject-tag-field"
                                placeholder="Adicione tags à Disciplina"
                                name="name"
                                id="name"
                                enterKeyHint="done"
                                onChange={onChangeTag}
                            />
                            <div className="Subject-tag-label-container">
                                <label className={tempTags.length > 0 && tempTags != 'Adicione tags à Disciplina' ? 'subject-label-btn' : 'subject-label-btn-hidden'}
                                    onClick={addTag}> Adicionar </label>
                            </div>

                        </div>
                        {subjectTags.length > 0 && <div className="new-subjects-tags">
                            <Grid container direction="row" justifyContent="flex-start" spacing={1}>
                                {renderTags()}
                            </Grid>

                        </div>}

                        {subjectId &&
                            <div className="new-subjects-modules-div">
                                <div className="new-subjects-modules-label">
                                    <label >Módulos <span className="gray">({subjectModules.length})</span> e Aulas <span className="gray">({totalClasses})</span></label>
                                </div>
                                <div className="new-subjects-modules-btn">
                                    <label onClick={() => { emptyClass(); setCreateType('aula') }}>
                                        <Button className={'outlined-button'}>
                                            <span>Nova Aula +</span>
                                        </Button>
                                    </label>
                                    <label onClick={() => setCreateType('modulo')}>
                                        <Button >
                                            <span>Novo Módulo +</span>
                                        </Button>
                                    </label>
                                </div>

                            </div>}

                        {createType == 'modulo' &&
                            <div className="new-subjects-modules-creation">
                                <div className="new-module-label">
                                    <label >Adicionar novo módulo </label>
                                </div>
                                <div className="new-subjects-input-label">
                                    <label className="new-subjects-input-label-text">Nome do Módulo</label>
                                    <TextField
                                        type="text"
                                        value={moduleName}
                                        placeholder="Nome do Módulo"
                                        name="name"
                                        id="name"
                                        className="Module-name-field"
                                        enterKeyHint="done"
                                        onChange={onChangeModuleName}
                                    />
                                </div>
                                <div className="new-modules-btn">
                                    <label onClick={() => setCreateType('')}>
                                        <Button className={'outlined-button'}>
                                            <span>Cancelar</span>
                                        </Button>
                                    </label>
                                    <div >
                                        <label onClick={() => addModule(false)}>
                                            <Button className="primary-button btn-left">
                                                <span>Concluir</span>
                                            </Button>
                                        </label>
                                        <label >
                                            <MenuButton className="primary-button btn-right" items={ModuleMenu}>
                                                <KeyboardArrowDownIcon />
                                            </MenuButton>
                                        </label>
                                    </div>
                                </div>

                            </div>}



                        {createType == 'aula' &&
                            renderSteps(classStep)}

                        {createType == 'editAula' &&
                            renderSteps(classStep)}

                        {
                            subjectModules.length > 0 && renderModules()
                        }


                    </div>
                </Grid>

            </Grid>}
            {viewAula && <ViewClasse goBack={() => setViewAula(false)} aula={subjectModules[moduleIndex].classList[classIndex]} index={classIndex + 1} modName={subjectModules[moduleIndex].name} />}
        </>


    );
}

export default NewSubject;
